module.exports = __webpack_public_path__ + "static/media/qrcode_assistant.d31a56e4.jpg";